/**
 * 花の店 あい花｜個人のお祝いLP
 * assets/celebration-lp.js
 *
 * ・FAQの開閉
 * ・スクロール時の軽いフェードイン
 * ・Shopifyテーマエディタでの再描画に対応
 * ・jQuery不使用
 */

(function () {
  'use strict';

  function initCelebration(root) {
    if (!root || root.dataset.celebrationInitialized === 'true') return;
    root.dataset.celebrationInitialized = 'true';

    // FAQ：同時に1つだけ開く場合は false のままにしてください。
    // 現在はHTML標準のdetailsとして複数開閉可能にしています。
    var accordion = root.querySelector('[data-accordion]');

    if (accordion) {
      var items = accordion.querySelectorAll('details');

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          // 必要であればここで「1つだけ開く」仕様へ変更できます。
        });
      });
    }

    // アニメーション対象。
    var animated = root.querySelectorAll(
      '.celebration-occasion, .celebration-scene, .celebration-product-card, .celebration-service-item, .celebration-step'
    );

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      });

      animated.forEach(function (item) {
        item.classList.add('celebration-reveal');
        observer.observe(item);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-celebration-section]').forEach(initCelebration);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editorでセクションが追加・再描画された場合。
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (!section) return;

    var root = section.querySelector('[data-celebration-section]') || (
      section.matches('[data-celebration-section]') ? section : null
    );

    initCelebration(root);
  });
})();
